import { useState, forwardRef, useEffect } from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Slide,
  AppBar,
  Toolbar,
  IconButton,
  Typography,
  Grid,
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

import request from "../../../utilities/requests";

const Transition = forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const PromptDialog = ({ open, close, prompt }) => {
  const [name, setName] = useState("");
  const [title, setTitle] = useState("");
  const [text, setText] = useState("");
  const [promptTypes, setPromptTypes] = useState([]);
  const [promptType, setPromptType] = useState("");

  const [confirmOpen, setConfirmOpen] = useState(false);

  useEffect(() => {
    if (prompt?.name) setName(prompt.name);
    if (prompt?.title) setTitle(prompt.title);
    if (prompt?.text) setText(prompt.text);
  }, [prompt]);

  const handleSave = async () => {
    const body = {
      id: prompt?._id,
      name,
      title,
      text,
    };
    if (prompt) {
      const result = await request("prompts/update", "post", body);
      if (result.success) {
        handleClose("update-success");
        return;
      }
    } else {
      const result = await request("prompts/create", "post", body);
      if (result.success) {
        handleClose("create-success");
        return;
      }
    }
  };

  const handleDelete = async () => {
    const body = { id: prompt._id };
    const result = await request("prompts/delete", "post", body);
    if (result.success) {
      setConfirmOpen(false);
      handleClose("delete-success");
    }
  };

  const handleClose = (msg) => {
    setName("");
    setTitle("");
    setText("");
    close(msg);
  };

  return (
    <>
      <Dialog
        fullScreen
        open={open}
        onClose={() => handleClose(null)}
        TransitionComponent={Transition}
      >
        <AppBar sx={{ position: "relative" }}>
          <Toolbar>
            <IconButton
              edge="start"
              color="inherit"
              onClick={() => handleClose(null)}
              aria-label="close"
            >
              <CloseIcon />
            </IconButton>
            <Typography sx={{ ml: 2, flex: 1 }} variant="h6" component="div">
              {prompt ? "Edit Prompt" : "New Prompt"}
            </Typography>
            <Button autoFocus color="inherit" onClick={handleSave}>
              save
            </Button>
          </Toolbar>
        </AppBar>

        <DialogContent>
          <Grid container direction="column" spacing={3}>
            <Grid item>
              <TextField
                fullWidth
                label="name*"
                value={name}
                onChange={(e) => setName(e.target.value)}
              />
              <Typography variant="caption" style={{ paddingLeft: 10 }}>
                Give your prompt a name
              </Typography>
            </Grid>

            <Grid item>
              <TextField
                fullWidth
                label="title"
                value={title}
                onChange={(e) => setTitle(e.target.value)}
              />
              <Typography variant="caption" style={{ paddingLeft: 10 }}>
                Depending on the prompt type, a title for the popup will appear.
              </Typography>
            </Grid>
            <Grid item>
              <TextField
                fullWidth
                label="text*"
                value={text}
                onChange={(e) => setText(e.target.value)}
              />
               <Typography variant="caption" style={{ paddingLeft: 10 }}>
                What should the prompt say? 
              </Typography>
            </Grid>
            <Grid item>
              <FormControl fullWidth>
                <InputLabel>prompt type</InputLabel>
                <Select
                  value={promptType}
                  label="prompt type"
                  onChange={(e) => setPromptType(e.target.value)}
                >
                  {promptTypes.map((option) => {
                    return (
                      <MenuItem key={option} value={option}>
                        {option}
                      </MenuItem>
                    );
                  })}
                </Select>
              </FormControl>
            </Grid>

            <Grid item>
              <Button
                variant="contained"
                onClick={handleSave}
                style={{ width: "100%" }}
              >
                Save
              </Button>
            </Grid>
            {prompt ? (
              <Grid item>
                <Button
                  variant="outlined"
                  onClick={() => setConfirmOpen(true)}
                  style={{ width: "100%" }}
                >
                  Delete
                </Button>
              </Grid>
            ) : (
              <></>
            )}
          </Grid>
        </DialogContent>
      </Dialog>
      <Dialog open={confirmOpen}>
        <DialogTitle id="alert-dialog-title">Please confirm</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Are you sure you want to delete this prompt?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setConfirmOpen(false)}>cancel</Button>
          <Button autoFocus onClick={handleDelete}>
            delete
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default PromptDialog;
